import NotificationModule from './Notification';

class NotificationData {
    value: string;
    title: string;
    type: 'neutral' | 'neutralSmall' | 'success' | 'successSmall' | 'info' | 'infoSmall' | 'error' | 'errorSmall';

    constructor(value: string, title: string, type: 'neutral' | 'neutralSmall' | 'success' | 'successSmall' | 'info' | 'infoSmall' | 'error' | 'errorSmall') {
        this.value = value;
        this.type = type;
        this.title = title;
    }
}

class NotificationQueue {
    static autoHide: boolean = true;    

    static push(notificationData: NotificationData): void {
        if (notificationData === undefined) {
            return;
        }

        NotificationModule.clear();        

        switch (notificationData.type) {
            case 'neutralSmall':
                NotificationModule.showNeutralSmall(notificationData.value, this.autoHide);
                break;
            case 'success':
                NotificationModule.showSuccess(notificationData.title, notificationData.value, this.autoHide);
                break;
            case 'successSmall':
                NotificationModule.showSuccessSmall(notificationData.value, this.autoHide);
                break;
            case 'info':
                NotificationModule.showInfo(notificationData.title, notificationData.value, this.autoHide);
                break;
            case 'infoSmall':
                NotificationModule.showInfoSmall(notificationData.value, this.autoHide);
                break;
            case 'error':
                NotificationModule.showError(notificationData.title, notificationData.value, this.autoHide);
                break;
            case 'errorSmall':
                NotificationModule.showErrorSmall(notificationData.value, this.autoHide);
                break;
            case 'neutral':
            default:
                NotificationModule.showNeutral(notificationData.title, notificationData.value, this.autoHide);
                break;
        }
    }    
}

export default NotificationQueue;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/NotificationQueue.tsx